<template>
  <VRow
    class="d-flex"
    :class="{'flex-column': $vuetify.breakpoint.smAndDown, 'pl-6': $vuetify.breakpoint.smAndUp }"
  >
    <VCol
      lg="3"
      md="3"
      sm="12"
      xs="12"
      class="d-flex align-items-center"
      :class="{'flex-column': $vuetify.breakpoint.mdAndUp}"
    >
      <div :class="{'w-100': $vuetify.breakpoint.mdAndUp}">
        <VIcon
          large
          class="checkout-icon"
          :class="{'pr-1': $vuetify.breakpoint.smAndDown }"
        >
          mdi-airplane
        </VIcon>
      </div>
      <div :class="{'w-100': $vuetify.breakpoint.mdAndUp}">
        <span class="body-bold">{{ $t('checkout.flightDetails') }}</span>
      </div>
    </VCol>
    <VCol
      cols="12"
      md="8"
      lg="8"
      sm="11"
    >
      <span
        class="body-2"
        v-html="$t('checkout.enterFlightDetails')"
      />
      <VTextField
        hide-details
        :value="flightDetails"
        :label="$t('checkout.flightNumber')"
        @input="updateFlightDetails"
      />
    </VCol>
  </VRow>
</template>

<script lang="ts">
export default {
  name: 'FlightDetails',
};
</script>

<script setup lang="ts">
defineProps({
  flightDetails: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['updateFlightDetails']);

function updateFlightDetails(newValue) {
  emit('updateFlightDetails', newValue);
}
</script>
